export default __webpack_public_path__ + "static/media/auction-img-left.ef73c3ad.png";